export default __webpack_public_path__ + "static/media/downloadsvg2.15d2fe77.svg";